import React, { useState } from 'react';
import styles from './LanguageSelector.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { changeLocale } from '../../../store/actions/settings';
import useComponentVisible from '../../../hooks/useComponentVisible';
import { countryCodes, getCountryByID } from '../../../constants/defaultValues';
import EngLogo from '../../../assets/images/flags/eng.png';
import AzeLogo from '../../../assets/images/flags/aze.png';

const languages = [
    {
        id: 1,
        value: getCountryByID(countryCodes.English).label,
        code: countryCodes.English,
        icon: EngLogo,
    },
    {
        id: 2,
        value: getCountryByID(countryCodes.Azerbaijan).label,
        code: countryCodes.Azerbaijan,
        icon: AzeLogo,
    },
];

const LanguageSelector = () => {
    const [items, ,] = useState(languages);
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

    const { locale } = useSelector(state => state.settings);
    const selectedItem = languages.find(language => language.code === locale);
    const dispatch = useDispatch();

    return (
        <div className={styles.languageSelector} ref={ref}>
            <div
                className={styles.selected}
                onClick={() => setIsComponentVisible(!isComponentVisible)}
            >
                <img src={selectedItem.icon} alt={selectedItem.value} className={styles.flag} />
                <span className={styles.title}>{selectedItem.value}</span>
                <i className='icon-arrow icon-arrow-down' />
            </div>
            {isComponentVisible && (
                <ul className={styles.languages}>
                    {items.map((item, index) => (
                        <li
                            key={item.id}
                            className={styles.language}
                            onClick={() => {
                                dispatch(changeLocale(item.code));
                                window.location.reload();
                            }}
                        >
                            <img src={item.icon} alt={item.value} className={styles.flag} />
                            <span>{item.value}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default LanguageSelector;
